import { Component, OnDestroy, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { forkJoin, Subscription } from "rxjs";
import { BOFilter } from "../models/BOFilter";
import { BOPerson } from "../models/BOPerson.model";
import { PersonService } from "../services/person.service";
import { ClinicHistoriesPatientComponent } from "./clinicHistoriesPatient.component";
import { CreateOrEditPatientComponent } from "./createOrEditPatient.component";
import { BODateRangeFilter } from "../models/BODateRangeFilter.model";
import { ClinicHistoryService } from "../services/clinicHistory.service";
import { BOPayTypeSellDetail } from "../models/BOPayTypeSellDetail.model";
import { ModalDirective } from "ngx-bootstrap/modal";
import { PayTypeSellDetailService } from "../services/payTypeSellDetail.service";
import { BOPayType } from "../models/BOPayType.model";
import { Utilities } from "../common/utilities";
import { PayTypeService } from "../services/payType.service";
import { BOInvoiceType } from "../models/BOInvoiceType.model";
import { InvoiceTypeService } from "../services/invoiceType.service";
import { SellComponent } from "./sell/sell.component";


@Component({
    templateUrl: './patients.component.html',
    styleUrls: [ './patients.component.css'],
})
export class PatientComponent implements OnDestroy {
    @ViewChild('createOrEditPatientModal', { static: true }) createOrEditPatientModal: CreateOrEditPatientComponent;
    @ViewChild('clinicHistoriesPatientModal', { static: true }) clinicHistoriesPatientModal: ClinicHistoriesPatientComponent;//new
    @ViewChild('modalPayTypeSellDetailList') public modalPayTypeSellDetailList: ModalDirective;
    @ViewChild('sellModal') public sellModal: SellComponent;



    patientList: BOPerson[];
    patientListFromHistories: BOPerson[]=[];
    busy: Subscription;
    busy2:Subscription;
    isClients: boolean;
    patientfilter:string = "";
    //filterRangeDates:BODateRangeFilter= new BODateRangeFilter();
    //filterRangeDates.starDate=null;
    filterRangesDates={
      startDate:null,
      endDate:null
    }
    areaSelected:number=null;
    payTypeSellDetailsList:BOPayTypeSellDetail[]=[];
    payTypeList:BOPayType[]
    invoiceTypeList:BOInvoiceType[]

    constructor(
      private _personService       : PersonService,
      public toastr                : ToastrService,
      private route                : ActivatedRoute,
      private _clinicHistoryService: ClinicHistoryService,
      private _toast               : ToastrService,
      private _payTypeSellDetailService:PayTypeSellDetailService,
      private _payTypeService     : PayTypeService,
      private _invoiceTypeService : InvoiceTypeService) {
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            const filterInput: BOFilter = {
                filter: this.patientfilter
            }
            if (params["isClient"])
            {
                this.isClients = params["isClient"] == 1 ? true : false;

                if (this.isClients)
                {
                  this.busy = forkJoin({
                              resultPatient                 : this._personService.getPatients(filterInput),
                              resultPayType                 : this._payTypeService.getAll(),
                              resultInvoiceType             : this._invoiceTypeService.getAll(),

                    }).subscribe(({ resultPatient,
                                    resultPayType,
                                    resultInvoiceType,
                            }) => {

                              this.patientList      = resultPatient;
                              this.payTypeList      = resultPayType;
                              this.invoiceTypeList  = resultInvoiceType;
                      });
                }

                else
                {
                  this.busy = forkJoin({
                              resultPatient                 : this._personService.getFuturePatients(),
                              resultPayType                 : this._payTypeService.getAll(),
                              resultInvoiceType             : this._invoiceTypeService.getAll(),

                    }).subscribe(({ resultPatient,
                                    resultPayType,
                                    resultInvoiceType,
                            }) => {

                              this.patientList      = resultPatient;
                              this.payTypeList      = resultPayType;
                              this.invoiceTypeList  = resultInvoiceType;
                      });
                }

            }
            else {
                // this.busy = this._personService.getPatients(filterInput).subscribe(data => { this.patientList = data });
                  this.busy = forkJoin({
                              resultPatient                 : this._personService.getPatients(filterInput),
                              resultPayType                 : this._payTypeService.getAll(),
                              resultInvoiceType             : this._invoiceTypeService.getAll(),

                    }).subscribe(({ resultPatient,
                                    resultPayType,
                                    resultInvoiceType,
                            }) => {

                              this.patientList      = resultPatient;
                              this.payTypeList      = resultPayType;
                              this.invoiceTypeList  = resultInvoiceType;
                      });


              }
        });
    }

    deletePatient(patientId: number) {
        if (confirm('Are you sure you want to delete this Patient?')) {
            this.busy = this._personService.deletePerson(patientId).subscribe(() => {
                this.toastr.warning('Patient Deleted');
                if (this.isClients) {
                    const filterInput: BOFilter = {
                        filter: this.patientfilter
                    }
                    this.busy = this._personService.getPatients(filterInput).subscribe(data => { this.patientList = data });
                }
                else {
                    this.busy = this._personService.getFuturePatients().subscribe(data => { this.patientList = data });
                }
            });
        }
    }

    getAllPatients(): void {
        if (this.isClients) {
            const filterInput: BOFilter = {
                filter: this.patientfilter.toUpperCase().trim()
            }
            this.busy = this._personService.getPatients(filterInput).subscribe(data => { this.patientList = data });
        }
        else {
            this.busy = this._personService.getFuturePatients().subscribe(data => { this.patientList = data });
        }
    }

    getClinicalHistoriesByAllAndDates():void
    {
      this.patientListFromHistories=[];
      this._clinicHistoryService.getCHWithPatientByDatesAndArea(this.filterRangesDates, this.areaSelected)
        .subscribe(data=>{

            if(data.length>0)
            {
                data.forEach(x=>{
                this.patientListFromHistories.push(x.patient);
            })

            this.patientList=null;
            this.patientList=this.patientListFromHistories;
           }
           else{
            this.patientList=null;
            this._toast.error('Fallo', 'No hay datos en la(s) fecha(s)')
           }


      });
    }

    getAllPayTypeSellDetailByPatientId(patientId:number)
    {
      this.payTypeSellDetailsList=[];
      this._payTypeSellDetailService.getAllPayTypeByPatientId(patientId)
          .subscribe({
            next:(data:BOPayTypeSellDetail[])=>{
              this.payTypeSellDetailsList=data;
              if(data.length>0)
              {
                this.modalPayTypeSellDetailList.config={backdrop:"static", keyboard:false};
                    this.modalPayTypeSellDetailList.show();
              }
              else{
                this.toastr.warning("Sin recibos", "No existen recibos para este paciente",{timeOut: 1500});
              }
            },
            error:(err)=>{
              this.toastr.warning("Fallo", "Falló la consulta");
            },
            complete:()=>{
              console.log('ptsd obtenidos x consulta');
            }

          });



    }

   getAllPayTypeSellDetailByPatientIdString(patientIdString:string)
    {
      this.payTypeSellDetailsList=[];
      this._payTypeSellDetailService.getAllPayTypeByPatientIdString(patientIdString)
          .subscribe({
            next:(data:BOPayTypeSellDetail[])=>{
              this.payTypeSellDetailsList=data;
              if(data.length>0)
              {
                this.modalPayTypeSellDetailList.config={backdrop:"static", keyboard:false};
                    this.modalPayTypeSellDetailList.show();
              }
              else{
                this.toastr.warning("Sin recibos", "No existen recibos para este paciente",{timeOut: 1500});
              }
            },
            error:(err)=>{
              this.toastr.warning("Fallo", "Falló la consulta");
            },
            complete:()=>{
              console.log('ptsd obtenidos x consulta');
            }

          });
    }



    closeModal(){
              this.modalPayTypeSellDetailList.hide();
    }

    getPayTypeNameFromUtiities(idPayType:number, payTypeList:BOPayType[]){
      return Utilities.getPayTypeName(idPayType, payTypeList);
    }

    getInvoiceNameFromUtilities(idInvoiceType, invoiceTypeList:BOInvoiceType[]){
      return Utilities.getInvoiceTypeName(idInvoiceType, invoiceTypeList);
    }



    ngOnDestroy(): void {
        this.busy?.unsubscribe();
        //this.busy2.unsubscribe();
    }
}
